export default "__VITE_ASSET__pCZvvYPz__"